import { TypeImage } from '@/core/generated-types';
import { ShopifyVariant } from '@/lib/shopify';

export const createImageEntry = (variant: ShopifyVariant) => {
  const imageUrl = variant.image.url.replace('https:', '');
  const date = new Date();

  const entry: TypeImage = {
    toPlainObject: function (): object {
      throw new Error('Function not implemented.');
    },
    update: function (): Promise<TypeImage> {
      throw new Error('Function not implemented.');
    },
    metadata: {
      tags: [],
    },
    sys: {
      space: {
        sys: {
          type: 'Link',
          linkType: 'Space',
          id: '0sea1vycfyqy',
        },
      },
      id: variant.id,
      type: 'Entry',
      createdAt: date.toISOString(),
      updatedAt: date.toISOString(),
      environment: {
        sys: {
          id: 'master',
          type: 'Link',
          linkType: 'Environment',
        },
      },
      revision: 1,
      contentType: {
        sys: {
          type: 'Link',
          linkType: 'ContentType',
          id: 'image',
        },
      },
      locale: 'en-US',
    },
    fields: {
      entryName: variant.title,
      Image: {
        toPlainObject: function (): object {
          throw new Error('Function not implemented.');
        },
        metadata: {
          tags: [],
        },
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: '0sea1vycfyqy',
            },
          },
          id: variant.id,
          type: 'Asset',
          createdAt: date.toISOString(),
          updatedAt: date.toISOString(),
          environment: {
            sys: {
              id: 'master',
              type: 'Link',
              linkType: 'Environment',
            },
          },
          revision: 1,
          locale: 'en-US',
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'image',
            },
          },
        },
        fields: {
          title: variant.title,
          description: '',
          file: {
            url: imageUrl,
            details: {
              size: 764331,
              image: {
                width: 849,
                height: 849,
              },
            },
            fileName: 'image.png',
            contentType: 'image/png',
          },
        },
      },
      altText: variant.image.altText,
      componentName: 'LuvImage',
    },
  };

  return entry;
};
